import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {}

  share (event) {
    event.preventDefault()

    if (typeof FB != 'undefined') {
      FB.ui(
        {
          method: 'share',
          href: window.location.href
        },
        function (response) {
          // TODO: do all the other modal, ask for social like stuff?
        }
      )
    }

    if (typeof window.posthog !== 'undefined') {
      window.posthog.capture('shared_content', {
        share_method: 'facebook',
        source: window.location.pathname
      })
    }
  }
}
